import {
  FETCH_SUPPORTTYPE_ACTION,
  FETCH_SUPPORTTYPE_SUCCESS_ACTION,
  FETCH_SUPPORTTYPE_FAIL_ACTION,
  FETCH_SUPPORTCENTER_ACTION,
  FETCH_SUPPORTCENTER_SUCCESS_ACTION,
  FETCH_SUPPORTCENTER_FAIL_ACTION,
} from "./action";
import { sortData } from "../../screens/Config/utils";
const initialState = {
  prcssng: false,
  error: false,
  supportType1: [{ value: "", name: "All" }],
  supportType: [],
  loading: true,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_SUPPORTTYPE_ACTION:
      return {
        ...state,
        processing: true,
        loading: true,
      };

    case FETCH_SUPPORTTYPE_SUCCESS_ACTION:
      let tempSupportTypeData = sortData(action.supportType);
      return {
        ...state,
        processing: false,
        error: false,
        errorCode: null,
        loading: false,
        errorMessage: null,
        supporttypeList: sortData(action.payload.rows),
        supportType: [...state.supportType1, ...tempSupportTypeData],
      };

    case FETCH_SUPPORTTYPE_FAIL_ACTION:
      return {
        ...state,
        processing: false,
      };

    case FETCH_SUPPORTCENTER_ACTION:
      return {
        ...state,
        processing: true,
      };

    case FETCH_SUPPORTCENTER_SUCCESS_ACTION:
     
      return {
        ...state,
        processing: false,
        error: false,
        errorCode: null,
        errorMessage: null,
        supportList: action.payload.rows,
        supportCount: action.payload.count,
      };

    case FETCH_SUPPORTCENTER_FAIL_ACTION:
      return {
        ...state,
        processing: false,
      };

    default:
      return {
        ...state,
      };
  }
}
